import React from "react";

const ConfirmPasswordImage = () => {
  return (
    <svg
      width="440"
      height="440"
      viewBox="0 0 440 440"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_500_1196)">
        <path
          opacity="0.18"
          d="M257.837 434.502C262.303 436.462 267.241 436.75 272.06 436.993C312.737 439.081 353.44 440.081 394.172 439.993C398.244 439.993 402.405 439.948 406.221 438.445C410.036 436.941 413.492 433.64 414.164 429.365C388.66 427.257 362.976 427.463 337.562 426.461C324.239 425.938 310.403 427.714 297.149 429.063C290.432 429.751 283.726 430.556 277.032 431.48C272.822 432.07 261.583 436.145 257.837 434.502Z"
          fill="white"
        />
        <path
          d="M337.493 421.169L340.629 429.372L327.957 435.755L316.254 436.661C316.254 436.661 314.253 428.458 319.717 427.728C322.911 427.34 325.958 426.086 328.567 424.088L337.493 421.169ZM347.554 424.876C345.966 425.574 344.585 426.717 343.558 428.183C342.532 429.65 341.898 431.385 341.724 433.204L341.384 436.661H355.774V424.869L347.554 424.876Z"
          fill="#95FD68"
        />
        <path
          opacity="0.22"
          d="M438.961 48.9819V253.785C438.962 256.765 438.411 259.716 437.34 262.47C436.269 265.224 434.698 267.726 432.718 269.833C430.738 271.94 428.388 273.612 425.8 274.752C423.213 275.892 420.44 276.478 417.64 276.477H21.3214C15.6666 276.477 10.2434 274.087 6.24488 269.831C2.24635 265.575 0 259.803 0 253.785V48.9819C0.00732906 42.9658 2.25604 37.1983 6.25298 32.9442C10.2499 28.6902 15.6688 26.2969 21.3214 26.2891H417.654C423.304 26.3008 428.719 28.6958 432.713 32.9494C436.707 37.2031 438.954 42.9683 438.961 48.9819Z"
          fill="white"
        />
        <path
          d="M439.999 49.2236V254.019C440 259.212 438.328 264.249 435.262 268.288C432.196 272.328 427.921 275.127 423.151 276.218C421.682 276.547 420.185 276.713 418.684 276.712H22.3517C19.5509 276.714 16.7772 276.128 14.1892 274.988C11.6012 273.849 9.24953 272.177 7.26874 270.07C5.28795 267.962 3.71685 265.46 2.64524 262.706C1.57363 259.952 1.02253 257 1.02344 254.019V49.2236C1.02894 43.2049 3.27779 37.4345 7.27643 33.1786C11.2751 28.9228 16.6968 26.5293 22.3517 26.5234H418.684C423.863 26.5244 428.864 28.5319 432.753 32.171C436.642 35.81 439.154 40.8316 439.819 46.2976C439.942 47.2674 440.002 48.245 439.999 49.2236Z"
          fill="white"
        />
        <path
          d="M439.999 50.2236V255.019C440 260.212 438.328 265.249 435.262 269.288C432.196 273.328 427.921 276.127 423.151 277.218C421.682 277.547 420.185 277.713 418.684 277.712H22.3517C19.5509 277.714 16.7772 277.128 14.1892 275.988C11.6012 274.849 9.24953 273.177 7.26874 271.07C5.28795 268.962 3.71685 266.46 2.64524 263.706C1.57363 260.952 1.02253 258 1.02344 255.019V50.2236C1.02894 44.2049 3.27779 38.4345 7.27643 34.1786C11.2751 29.9228 16.6968 27.5293 22.3517 27.5234H418.684C423.863 27.5244 428.864 29.5319 432.753 33.171C436.642 36.81 439.154 41.8316 439.819 47.2976C439.942 48.2674 440.002 49.245 439.999 50.2236Z"
          fill="url(#paint0_linear_500_1196)"
        />
        <path
          d="M439.795 46.0633H1.17969C1.84582 40.5966 4.35878 35.5749 8.24926 31.936C12.1397 28.2971 17.1417 26.2898 22.321 26.2891H418.653C423.833 26.2883 428.836 28.295 432.727 31.9342C436.617 35.5734 439.13 40.596 439.795 46.0633Z"
          fill="#03151C"
        />
        <path
          d="M286.478 205.636H138.108C135.079 205.636 132.623 208.249 132.623 211.473V221.076C132.623 224.3 135.079 226.913 138.108 226.913H286.478C289.507 226.913 291.962 224.3 291.962 221.076V211.473C291.962 208.249 289.507 205.636 286.478 205.636Z"
          fill="white"
          stroke="#95FD68"
          stroke-width="0.88"
          stroke-miterlimit="10"
        />
        <path
          d="M145.614 221.194C148.02 221.194 149.97 219.118 149.97 216.558C149.97 213.997 148.02 211.922 145.614 211.922C143.208 211.922 141.258 213.997 141.258 216.558C141.258 219.118 143.208 221.194 145.614 221.194Z"
          fill="#95FD68"
        />
        <path
          d="M159.166 221.194C161.571 221.194 163.521 219.118 163.521 216.558C163.521 213.997 161.571 211.922 159.166 211.922C156.76 211.922 154.81 213.997 154.81 216.558C154.81 219.118 156.76 221.194 159.166 221.194Z"
          fill="#95FD68"
        />
        <path
          d="M172.725 221.194C175.13 221.194 177.08 219.118 177.08 216.558C177.08 213.997 175.13 211.922 172.725 211.922C170.319 211.922 168.369 213.997 168.369 216.558C168.369 219.118 170.319 221.194 172.725 221.194Z"
          fill="#95FD68"
        />
        <path
          d="M186.276 221.194C188.682 221.194 190.632 219.118 190.632 216.558C190.632 213.997 188.682 211.922 186.276 211.922C183.871 211.922 181.921 213.997 181.921 216.558C181.921 219.118 183.871 221.194 186.276 221.194Z"
          fill="#95FD68"
        />
        <path
          d="M302.716 215.29V212.843H304.531V211.266H302.716V210.087H304.531V208.51H300.895V215.29C299.79 215.53 298.809 216.199 298.141 217.165C297.473 218.132 297.166 219.328 297.279 220.522C297.393 221.715 297.918 222.822 298.755 223.627C299.591 224.431 300.678 224.877 301.806 224.877C302.933 224.877 304.02 224.431 304.857 223.627C305.693 222.822 306.219 221.715 306.332 220.522C306.446 219.328 306.138 218.132 305.47 217.165C304.802 216.199 303.821 215.53 302.716 215.29ZM301.809 223.398C301.183 223.399 300.57 223.203 300.049 222.833C299.528 222.464 299.121 221.939 298.88 221.323C298.64 220.708 298.576 220.031 298.698 219.377C298.819 218.723 299.12 218.122 299.562 217.65C300.004 217.179 300.568 216.857 301.182 216.726C301.796 216.596 302.433 216.662 303.012 216.917C303.59 217.172 304.085 217.603 304.433 218.157C304.781 218.711 304.967 219.363 304.967 220.029C304.967 220.922 304.635 221.778 304.043 222.411C303.451 223.044 302.648 223.401 301.809 223.405V223.398Z"
          fill="#95FD68"
        />
        <path
          d="M239.348 92.7393H193.907C189.41 92.7393 185.764 96.6198 185.764 101.407V149.77C185.764 154.557 189.41 158.437 193.907 158.437H239.348C243.845 158.437 247.491 154.557 247.491 149.77V101.407C247.491 96.6198 243.845 92.7393 239.348 92.7393Z"
          fill="url(#paint1_linear_500_1196)"
        />
        <path
          d="M239.597 92.7393H197.432C193.076 92.7393 189.545 96.4977 189.545 101.134V150.042C189.545 154.679 193.076 158.437 197.432 158.437H239.597C243.953 158.437 247.484 154.679 247.484 150.042V101.134C247.484 96.4977 243.953 92.7393 239.597 92.7393Z"
          fill="#313131"
        />
        <path
          d="M249.873 125.801L246.688 129.022L245.303 130.408C244.212 129.021 242.826 127.93 241.261 127.224C239.696 126.518 237.996 126.217 236.301 126.347C235.56 126.442 234.808 126.312 234.133 125.971C231.841 124.585 235.435 119.861 235.435 119.861C236.226 119.843 237.017 119.88 237.804 119.972C237.873 119.964 237.942 119.964 238.011 119.972L238.641 120.053C241.647 120.51 246.543 122.035 249.873 125.801Z"
          fill="white"
        />
        <path
          opacity="0.39"
          d="M246.564 128.72L246.688 129.022L245.303 130.408C244.212 129.021 242.826 127.93 241.261 127.224C239.696 126.518 237.996 126.218 236.301 126.347C235.56 126.443 234.808 126.312 234.134 125.971L235.435 119.861C235.435 119.861 236.716 119.861 237.804 119.972C237.873 119.965 237.942 119.965 238.011 119.972C238.223 119.985 238.433 120.012 238.642 120.053C238.642 120.053 239.396 123.487 238.835 124.932C238.835 124.954 244.147 125.898 246.564 128.72Z"
          fill="url(#paint2_linear_500_1196)"
        />
        <path
          d="M217.701 106.588H215.554C213.829 106.588 212.431 108.076 212.431 109.912V141.265C212.431 143.1 213.829 144.589 215.554 144.589H217.701C219.426 144.589 220.824 143.1 220.824 141.265V109.912C220.824 108.076 219.426 106.588 217.701 106.588Z"
          fill="url(#paint3_linear_500_1196)"
        />
        <path
          d="M236.287 125.072C236.252 129.051 234.744 132.854 232.09 135.655C229.436 138.457 225.85 140.03 222.112 140.034H219.058C218.597 140.033 218.146 139.895 217.755 139.634C217.364 139.374 217.05 139.001 216.849 138.56C216.663 138.16 216.575 137.717 216.595 137.271C216.615 136.825 216.742 136.392 216.963 136.014C217.184 135.635 217.493 135.322 217.86 135.106C218.226 134.89 218.639 134.777 219.058 134.779H220.194C221.425 134.779 222.644 134.518 223.779 134.01C224.913 133.502 225.942 132.758 226.803 131.822C227.664 130.885 228.341 129.775 228.793 128.557C229.246 127.338 229.465 126.036 229.438 124.726C229.355 122.129 228.323 119.669 226.562 117.87C224.8 116.071 222.448 115.074 220.007 115.093H218.622C218.086 115.093 217.571 114.866 217.192 114.463C216.813 114.059 216.6 113.512 216.6 112.941V112.027C216.6 111.456 216.813 110.909 217.192 110.505C217.571 110.102 218.086 109.875 218.622 109.875H221.87C229.715 109.868 236.342 116.707 236.287 125.072Z"
          fill="white"
        />
        <path
          opacity="0.39"
          d="M232.506 125.676C232.479 129.136 231.169 132.444 228.862 134.881C226.555 137.319 223.437 138.688 220.187 138.692H217.528C217.293 138.692 217.059 138.652 216.835 138.574C216.649 138.175 216.561 137.731 216.581 137.285C216.601 136.84 216.728 136.407 216.949 136.028C217.17 135.649 217.479 135.337 217.846 135.121C218.213 134.905 218.625 134.792 219.044 134.793H220.18C221.411 134.793 222.63 134.532 223.765 134.024C224.9 133.517 225.928 132.773 226.789 131.836C227.65 130.9 228.327 129.79 228.779 128.571C229.232 127.353 229.451 126.05 229.425 124.74C229.342 122.143 228.309 119.683 226.548 117.884C224.786 116.085 222.434 115.089 219.993 115.107H218.608C218.072 115.107 217.557 114.881 217.178 114.477C216.799 114.073 216.586 113.526 216.586 112.955V112.55C216.765 112.488 216.952 112.455 217.14 112.454H219.958C223.267 112.446 226.444 113.833 228.795 116.31C231.146 118.788 232.48 122.155 232.506 125.676Z"
          fill="url(#paint4_linear_500_1196)"
        />
        <path
          d="M228.995 121.954C228.995 121.954 229.923 124.6 228.767 128.639C228.767 128.639 224.383 133.437 228.123 141.065L231.211 144.581L227.617 148.347C225.383 146.505 223.65 144.064 222.595 141.275C221.54 138.485 221.201 135.446 221.613 132.471C222.41 125.971 228.995 121.954 228.995 121.954Z"
          fill="white"
        />
        <path
          d="M224.55 151.383L253.01 122.64L276.887 144.581L247.484 174.599L224.55 151.383ZM224.55 151.383L226.44 162.778L247.484 184.269V174.599L224.55 151.383Z"
          fill="#95FD68"
        />
        <path
          d="M276.887 144.581V155.039L247.484 184.27V174.6L276.887 144.581Z"
          fill="#95FD68"
        />
        <path
          d="M224.55 151.384L226.44 162.778L247.484 184.27V174.6L224.55 151.384Z"
          fill="url(#paint5_linear_500_1196)"
        />
        <path
          d="M276.887 144.581V155.039L247.484 184.27V174.6L276.887 144.581Z"
          fill="url(#paint6_linear_500_1196)"
        />
        <path
          d="M229.799 156.698L258.529 127.711L261.182 130.15L232.506 159.44L229.799 156.698Z"
          fill="url(#paint7_linear_500_1196)"
        />
        <path
          d="M238.281 165.092L267.698 136.105L270.35 138.538L240.989 167.827L238.281 165.092Z"
          fill="url(#paint8_linear_500_1196)"
        />
        <path
          opacity="0.21"
          d="M320.34 193.629C320.051 198.182 320.283 202.756 321.032 207.249C321.503 210.028 322.133 213.086 320.79 215.533C320.097 216.86 318.851 217.789 317.736 218.769C310.659 224.96 306.566 234.15 300.521 241.476C300.121 242.079 299.54 242.518 298.873 242.722C298.188 242.769 297.508 242.564 296.948 242.14C293.267 239.879 290.173 236.677 287.946 232.824C286.859 230.937 285.868 228.785 283.999 227.819C280.536 226.006 276.34 229.861 275.959 233.966C275.578 238.071 277.649 241.933 279.65 245.464L288.908 261.811C291.727 266.793 294.697 271.945 299.295 275.077C302.478 277.142 306.052 278.426 309.759 278.836C315.008 279.573 320.333 279.204 325.617 278.769C335.279 277.974 344.916 276.952 354.527 275.703C357.824 275.276 361.57 274.51 363.239 271.466C364.361 269.417 364.208 266.889 364.014 264.53C363.336 255.986 362.643 247.444 361.937 238.904C361.556 234.062 360.988 228.8 357.782 225.35C355.864 223.301 353.177 222.137 351.474 219.874C350.256 218.061 349.472 215.958 349.188 213.75C347.547 204.537 349.119 194.639 345.726 185.964C345.034 184.21 344.106 182.471 342.575 181.49C341.17 180.715 339.589 180.376 338.012 180.51C330.429 180.739 320.894 184.586 320.34 193.629Z"
          fill="url(#paint9_linear_500_1196)"
        />
        <path
          opacity="0.18"
          d="M423.36 323.713C419.253 374.074 289.075 357.94 195.459 337.525C101.843 317.11 24.6038 357.94 6.79324 323.713C-1.09407 308.56 4.17568 289.633 12.5062 273.242C15.6813 275.126 19.2584 276.108 22.8933 276.094H415.694C421.102 289.648 424.821 305.863 423.36 323.713Z"
          fill="white"
        />
        <path
          d="M321.095 302.789L312.57 368.87C312.213 371.652 312.486 374.485 313.367 377.132L328.601 424.876L337.506 421.928L330.789 374.427C330.646 373.442 330.707 372.436 330.969 371.479L342.527 328.997L347.554 424.81H355.774L362.844 330.258C365.24 314.456 360.85 302.789 360.85 302.789H321.095Z"
          fill="white"
        />
        <path
          d="M364.783 285.292L356.349 227.466L355.172 220.42C355.172 220.42 370.919 230.001 375.433 246.761C381.34 268.761 364.783 285.292 364.783 285.292Z"
          fill="#95FD68"
        />
        <path
          d="M364.783 285.292L356.349 227.466L355.172 220.42C355.172 220.42 370.919 230.001 375.434 246.761C381.34 268.761 364.783 285.292 364.783 285.292Z"
          fill="url(#paint10_linear_500_1196)"
        />
        <path
          d="M373.439 271.835C379.831 258.384 367.207 234.984 367.207 234.984L356.335 227.473L357.561 219.123C357.561 219.123 375.094 221.032 376.805 247.38C377.372 255.863 376.777 266.344 373.439 271.835Z"
          fill="#95FD68"
        />
        <path
          d="M283.105 226.685C282.517 224.562 281.492 222.034 279.415 221.842C279.978 223.778 279.895 225.861 279.179 227.738C274.65 225.955 273.598 218.894 269.076 217.066C268.383 217.848 268.771 219.123 269.201 220.096C269.99 221.909 270.784 223.722 271.583 225.535C270.521 223.756 269.392 222.036 268.196 220.376C267.843 219.867 267.234 219.314 266.735 219.639C266.237 219.963 266.417 220.648 266.597 221.179C267.386 223.537 268.286 225.859 269.277 228.129C268.165 226.143 266.893 224.264 265.475 222.513C264.547 222.756 264.741 224.215 265.143 225.137L268.113 231.873L265.731 228.188C264.963 228.269 265.08 229.522 265.454 230.244C268.649 236.315 273.64 241.09 279.65 243.828C280.869 244.38 282.281 244.837 283.479 244.24C288.631 241.742 284.103 230.325 283.105 226.685Z"
          fill="white"
        />
        <path
          d="M364.783 244.572V289.914C364.783 295.471 363.931 299.989 358.703 299.989H322.196C316.988 299.989 316.787 295.515 316.753 289.98L316.483 259.165C316.483 259.165 308.602 274.105 302.315 272.653C296.027 271.201 277.385 243.85 277.385 243.85L286.665 235.551L302.301 252.237C302.301 252.237 304.815 246.157 308.471 232.544C312.127 218.931 324.01 218.895 324.01 218.895H355.753C367.214 218.895 364.783 244.572 364.783 244.572Z"
          fill="#95FD68"
        />
        <path
          d="M364.783 249.68C364.783 249.68 370.268 257.883 364.783 266.086V249.68Z"
          fill="#3D4F56"
        />
        <path
          d="M321.095 299.701H360.85V302.789H321.095V299.701Z"
          fill="url(#paint11_linear_500_1196)"
        />
        <path
          d="M334.633 188.058H346.107V219.108H334.633V188.058Z"
          fill="url(#paint12_linear_500_1196)"
        />
        <path
          d="M346.114 184.652V219.115H340.062V217.015C340.062 216.403 339.948 215.798 339.728 215.233C339.508 214.669 339.186 214.156 338.779 213.724C338.373 213.292 337.89 212.949 337.359 212.716C336.829 212.483 336.26 212.363 335.685 212.364H335.339C332.456 212.364 329.69 211.145 327.651 208.975C325.612 206.805 324.467 203.862 324.467 200.793V184.652H346.114Z"
          fill="white"
        />
        <path
          d="M324.467 188.058C324.467 188.058 314.426 182.228 318.02 175.846C321.614 169.463 327.472 173.48 327.472 173.48H346.827C346.827 173.48 349.05 173.111 349.909 177.121C350.767 181.13 346.142 206.019 346.142 206.019H336.523L335.29 199.548C335.29 199.548 337.209 197.337 337.036 194.986C337.052 194.546 336.925 194.113 336.676 193.761C336.428 193.409 336.073 193.159 335.671 193.052C335.27 192.946 334.846 192.99 334.472 193.177C334.097 193.364 333.794 193.683 333.615 194.079C332.749 195.716 333.095 188.788 330.014 188.058C328.188 187.617 326.293 187.617 324.467 188.058Z"
          fill="#03151C"
        />
        <path
          d="M343.545 219.049C343.545 219.049 339.092 225.255 332.922 225.255C326.752 225.255 308.776 244.027 307.571 249.68C306.366 255.333 302.315 252.237 302.315 252.237C302.315 252.237 304.828 246.157 308.485 232.544C312.141 218.931 324.01 218.895 324.01 218.895H340.145L343.545 219.049Z"
          fill="url(#paint13_linear_500_1196)"
        />
        <path
          d="M337.493 421.169L340.629 429.372L327.957 435.755L316.254 436.661C316.254 436.661 314.253 428.458 319.717 427.728C322.911 427.34 325.958 426.086 328.567 424.088L337.493 421.169Z"
          fill="url(#paint14_linear_500_1196)"
        />
        <path
          d="M347.554 424.877C345.966 425.574 344.585 426.717 343.558 428.184C342.532 429.65 341.898 431.385 341.724 433.205L341.384 436.661H355.774V424.869L347.554 424.877Z"
          fill="url(#paint15_linear_500_1196)"
        />
        <path
          opacity="0.18"
          d="M83.1873 26.6725C83.1873 26.6725 172.074 -33.3429 285.903 26.6725H83.1873Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_500_1196"
          x1="-62.5944"
          y1="91.1208"
          x2="608.515"
          y2="219.82"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_500_1196"
          x1="217.369"
          y1="125.286"
          x2="79.181"
          y2="174.278"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#03151C" />
          <stop offset="0.01" stop-color="#03151C" />
          <stop offset="0.12" stop-color="#03151C" />
          <stop offset="0.24" stop-color="#4F585C" />
          <stop offset="0.37" stop-color="#4C7B8B" />
          <stop offset="0.5" stop-color="#466773" />
          <stop offset="0.63" stop-color="#425A63" />
          <stop offset="0.79" stop-color="#405359" />
          <stop offset="0.99" stop-color="#3D4F56" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_500_1196"
          x1="234.12"
          y1="125.138"
          x2="246.688"
          y2="125.138"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#95FD68" />
          <stop offset="1" stop-color="#90EB69" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_500_1196"
          x1="207.702"
          y1="125.551"
          x2="278.729"
          y2="125.766"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-opacity="0" />
          <stop offset="0.02" stop-color="#030404" stop-opacity="0.04" />
          <stop offset="0.18" stop-color="#181F21" stop-opacity="0.39" />
          <stop offset="0.35" stop-color="#283539" stop-opacity="0.66" />
          <stop offset="0.53" stop-color="#344449" stop-opacity="0.85" />
          <stop offset="0.73" stop-color="#3B4D53" stop-opacity="0.96" />
          <stop offset="0.99" stop-color="#3D4F56" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_500_1196"
          x1="243.78"
          y1="124.696"
          x2="222.158"
          y2="125.366"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#95FD68" />
          <stop offset="1" stop-color="#90EB69" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_500_1196"
          x1="230.581"
          y1="183.304"
          x2="256.461"
          y2="118.252"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-opacity="0" />
          <stop offset="0.02" stop-color="#030404" stop-opacity="0.04" />
          <stop offset="0.18" stop-color="#181F21" stop-opacity="0.39" />
          <stop offset="0.35" stop-color="#283539" stop-opacity="0.66" />
          <stop offset="0.53" stop-color="#344449" stop-opacity="0.85" />
          <stop offset="0.73" stop-color="#3B4D53" stop-opacity="0.96" />
          <stop offset="0.99" stop-color="#3D4F56" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_500_1196"
          x1="265.648"
          y1="177.26"
          x2="245.876"
          y2="112.489"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-opacity="0" />
          <stop offset="0.02" stop-color="#030404" stop-opacity="0.04" />
          <stop offset="0.18" stop-color="#181F21" stop-opacity="0.39" />
          <stop offset="0.35" stop-color="#283539" stop-opacity="0.66" />
          <stop offset="0.53" stop-color="#344449" stop-opacity="0.85" />
          <stop offset="0.73" stop-color="#3B4D53" stop-opacity="0.96" />
          <stop offset="0.99" stop-color="#3D4F56" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_500_1196"
          x1="257.345"
          y1="125.463"
          x2="161.803"
          y2="253.302"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-opacity="0" />
          <stop offset="0.02" stop-color="#030404" stop-opacity="0.04" />
          <stop offset="0.18" stop-color="#181F21" stop-opacity="0.39" />
          <stop offset="0.35" stop-color="#283539" stop-opacity="0.66" />
          <stop offset="0.53" stop-color="#344449" stop-opacity="0.85" />
          <stop offset="0.73" stop-color="#3B4D53" stop-opacity="0.96" />
          <stop offset="0.99" stop-color="#3D4F56" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_500_1196"
          x1="266.964"
          y1="132.649"
          x2="171.421"
          y2="260.495"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-opacity="0" />
          <stop offset="0.02" stop-color="#030404" stop-opacity="0.04" />
          <stop offset="0.18" stop-color="#181F21" stop-opacity="0.39" />
          <stop offset="0.35" stop-color="#283539" stop-opacity="0.66" />
          <stop offset="0.53" stop-color="#344449" stop-opacity="0.85" />
          <stop offset="0.73" stop-color="#3B4D53" stop-opacity="0.96" />
          <stop offset="0.99" stop-color="#3D4F56" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_500_1196"
          x1="294.413"
          y1="201.869"
          x2="478.1"
          y2="364.361"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-opacity="0" />
          <stop offset="0.02" stop-color="#030404" stop-opacity="0.04" />
          <stop offset="0.18" stop-color="#181F21" stop-opacity="0.39" />
          <stop offset="0.35" stop-color="#283539" stop-opacity="0.66" />
          <stop offset="0.53" stop-color="#344449" stop-opacity="0.85" />
          <stop offset="0.73" stop-color="#3B4D53" stop-opacity="0.96" />
          <stop offset="0.99" stop-color="#3D4F56" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_500_1196"
          x1="379.658"
          y1="246.665"
          x2="230.25"
          y2="288.116"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-opacity="0" />
          <stop offset="0.02" stop-color="#030404" stop-opacity="0.04" />
          <stop offset="0.18" stop-color="#181F21" stop-opacity="0.39" />
          <stop offset="0.35" stop-color="#283539" stop-opacity="0.66" />
          <stop offset="0.53" stop-color="#344449" stop-opacity="0.85" />
          <stop offset="0.73" stop-color="#3B4D53" stop-opacity="0.96" />
          <stop offset="0.99" stop-color="#3D4F56" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_500_1196"
          x1="321.095"
          y1="301.249"
          x2="360.85"
          y2="301.249"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#95FD68" />
          <stop offset="1" stop-color="#90EB69" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_500_1196"
          x1="336.828"
          y1="203.653"
          x2="355.671"
          y2="203.334"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#D0ECC4" />
          <stop offset="0.42" stop-color="#DAEFD1" />
          <stop offset="1" stop-color="#D5F2C9" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_500_1196"
          x1="346.689"
          y1="245.611"
          x2="296.921"
          y2="227.304"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_500_1196"
          x1="315.894"
          y1="428.915"
          x2="340.629"
          y2="428.915"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-opacity="0" />
          <stop offset="0.02" stop-color="#030404" stop-opacity="0.04" />
          <stop offset="0.18" stop-color="#181F21" stop-opacity="0.39" />
          <stop offset="0.35" stop-color="#283539" stop-opacity="0.66" />
          <stop offset="0.53" stop-color="#344449" stop-opacity="0.85" />
          <stop offset="0.73" stop-color="#3B4D53" stop-opacity="0.96" />
          <stop offset="0.99" stop-color="#3D4F56" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_500_1196"
          x1="341.37"
          y1="430.773"
          x2="355.76"
          y2="430.773"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-opacity="0" />
          <stop offset="0.02" stop-color="#030404" stop-opacity="0.04" />
          <stop offset="0.18" stop-color="#181F21" stop-opacity="0.39" />
          <stop offset="0.35" stop-color="#283539" stop-opacity="0.66" />
          <stop offset="0.53" stop-color="#344449" stop-opacity="0.85" />
          <stop offset="0.73" stop-color="#3B4D53" stop-opacity="0.96" />
          <stop offset="0.99" stop-color="#3D4F56" />
        </linearGradient>
        <clipPath id="clip0_500_1196">
          <rect width="440" height="440" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ConfirmPasswordImage;
